import {UA} from '@colonist/mobile'

export class UIDeviceController {
    static _isUserOnMobileWebview: boolean | undefined = undefined
    static _isCypressTest: boolean | undefined = undefined

    static isUserOnTabletApp() {
        if(window.location.hostname.includes('discordsays')) return false
        if(this.isUserOnMobileAppOrWeb() && window.location.search.includes('tablet=1')) return true

        const userAgent = navigator.userAgent
        const tabletUserAgents = [UA.IPAD_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT]
        return tabletUserAgents.includes(userAgent)
    }

    static isUserOnMobileAppOrWeb(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const isMobileWebViewAgent = UA.isMobileAppUserAgent(userAgent)
        if(isMobileWebViewAgent) return true

        const isMobilePath = window.location.pathname.includes('/mobile')
        return isMobilePath
    }

    static isUserOnIOSApp(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const iosUserAgents = [UA.IPHONE_APP_USER_AGENT, UA.IPAD_APP_USER_AGENT]
        return iosUserAgents.includes(userAgent)
    }

    static isUserOnAndroidApp(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const androidUserAgents = [UA.ANDROID_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT]
        return androidUserAgents.includes(userAgent)
    }

    static isUserOnDiscordMobile() {
        if(!this.isUserOnDiscord()) return false
        if(!this.isUserOnMobileDevice()) return false

        return true
    }

    static isUserOnDiscord() {
        return window.location.hostname.includes('discordsays')
    }

    static isUserOnFirefox(): boolean {
        const userAgent = navigator.userAgent
        return userAgent.includes('Firefox') || userAgent.includes('FxiOS')
    }

    static isUserOnSafariOrIOS(): boolean {
        const userAgent = navigator.userAgent.toLowerCase()
        const isIOS = /ipad|iphone|ipod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome')
        return isIOS || isSafari
    }

    static isUserOnMobileWebview(): boolean {
        if(this._isUserOnMobileWebview != undefined) return this._isUserOnMobileWebview

        this._isUserOnMobileWebview = this.isUserOnMobileAppOrWeb() || this.isUserOnTabletApp() || this.isUserOnDiscordMobile()
        return this._isUserOnMobileWebview
    }

    static isCypressTest(): boolean {
        if(this._isCypressTest != undefined) return this._isCypressTest

        this._isCypressTest = typeof (window as any).Cypress !== 'undefined'
        return this._isCypressTest
    }

    static isUserOnMobileDevice(): boolean {
        const userAgent = navigator.userAgent
        return UA.isMobileDeviceUserAgent(userAgent)
    }

    static isUserOnTabletDevice(): boolean {
        const userAgent = navigator.userAgent
        return UA.isTabletDeviceUserAgent(userAgent)
    }

    static isUserOnMobileWebBrowser(): boolean {
        if(window.location.hostname.includes('discordsays')) return false
        if(!this.isUserOnMobileDevice()) return false

        const userAgent = navigator.userAgent
        const isMobileWebViewAgent = UA.isMobileAppUserAgent(userAgent)
        return !isMobileWebViewAgent
    }
}
